export default __webpack_public_path__ + "static/media/opium.31d3c4a9.png";